export function isRealUserInteraction(event: Event) {
    const eventType = event.type.toLowerCase();
    return eventType.includes('pointerdown') ||
        eventType.includes('mousedown') ||
        eventType.includes('touchstart') ||
        eventType.includes('click') ||
        eventType.includes('focus');
}

export const preventDefaultIfNotRealUserInteraction = function(event: Event) {

    // Si c'est une vraie interaction utilisateur (basé sur le type), laisser fermer
    if (isRealUserInteraction(event)) {
        return; // Laisser fermer normalement
    }

    // Sinon, c'est probablement un rerender/événement synthétique
    // Empêcher la fermeture
    event.preventDefault();
}